<template>
   <div>
    <Nav />
    <div class="pageWD shadowBox mT20 minHeight">    
     <div class="mainTop f18 c3" >文件查看</div> 
     <div class="viewpage" v-if="detail">   
        <div class="p24" >
            <div class="f16"><span class="c9">文件名称：</span><span class="c3">{{detail.fiName}}</span></div>
            <div class="f16"><span class="c9">文件大小：</span><span class="c3">{{detail.fiSize}}KB</span></div>            
        </div> 
        <div>
            <div v-if="detail.fiFiletype=='1'" v-loading="loading">
                    <div class="flex pdf-tab " >
                        <div class="flex">
                            <div class="btn-def btn-pre" @click.stop="prePage">上一页</div>
                            <div class="btn-def btn-next" @click.stop="nextPage">下一页</div>
                        </div>
                        <div>{{pageNum}}/{{pageTotalNum}}</div>
                        <div>进度：{{loadedRatio}}</div>
                    </div>                
                    <pdf 
                        ref="pdf"
                        :src="detail.fiUrl"
                        :page="pageNum"
                        :rotate="pageRotate"   
                        @progress="loadedRatio = $event"
                        @page-loaded="pageLoaded($event)"
                        @num-pages="pageTotalNum=$event" 
                        @error="pdfError($event)"
                        @link-clicked="page = $event">
                    </pdf>            
            </div> 
            <div v-else-if="detail.fiFiletype=='2' || detail.fiFiletype=='3' ||detail.fiFiletype=='4'">
                <iframe class="ifa" :src="'https://view.officeapps.live.com/op/view.aspx?src='+encodeURIComponent(detail.fiUrl)" :style="{'height':wHeight+'px'}" frameborder="0"></iframe>
            </div> 
            <div v-else-if="detail.fiFiletype=='5'" >
                <img style="max-width:1100px;margin:0 auto;" :src="detail.fiUrl" />           
            </div>
            <div class="ifa" v-else-if="detail.fiFiletype=='6'">
                <video :src="detail.fiUrl"  controls="controls" style="width:500px; height:400px"  @timeupdate="onTimeupdate"  @play="onPlay"  @pause="onPause"/>
            </div>
            <div class="ifa" v-else-if="detail.fiFiletype=='7'">             
                <audio :src="detail.fiUrl" controls="controls" style="margin-top:200px"  @timeupdate="onTimeupdate"  @play="onPlay"  @pause="onPause"></audio>
            </div>
            <div v-else-if="detail.fiFiletype=='8'">
                <iframe class="ifa" :src="detail.fiUrl" :style="{'height':wHeight+'px'}" frameborder="0"></iframe>
            </div>
            <div v-else>
                <Empty />
            </div>  
        </div>
     </div>
  </div>
 </div>
</template>
<script>
import Cookies from "js-cookie";
import Empty from "../../components/Empty.vue";
import Nav from "../../components/Nav.vue";
import Pdf from "vue-pdf";
import { addWatchClassH ,addReadStatus ,getFile} from '@/api/api'
export default {
  components: { Empty ,Nav, Pdf },
   data() {
      return {       
        src: '',
        fullscreenLoading: true,
        numPages: undefined,
        // fiFiletype:this.$route.query.fiFiletype,//fiFiletype" : 文件类型 1 pdf 2 word 3 excel 4 ppt 5 图片 6 视频 7 音频 8 txt
        // fiUrl:this.$route.query.fiUrl,
        fiId:this.$route.query.fiId,      
        wHeight:document.body.offsetHeight,
        timer:'',
        TotalTime: 0,
        timerVd:'',
        TotalVd:0,
        pageNum:1,
        pageTotalNum:1,
        pageRotate:0,     
        loadedRatio:0 , // 加载进度   
        loading: true,
        taskId:this.$route.query.taskId||'0',
        taskTI_ID:this.$route.query.taskTI_ID||'0',
        detail:null
      };             
    },
    created() {       
        this.loading = true  
        this.getFileFun()   
        this.addReadStatus()         
    }, 
    watch:{
        loadedRatio() {
            this.loading =  this.loadedRatio =='1'?false:true;
        }
    },
    mounted() {    
         window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    },
   
    methods: { 
        getFileFun(){
           var that = this
           var data = {
            id: that.fiId       
          } 
          getFile(data)
          .then(res => {    
                  
                that.detail =  res.body.result  
                var fiFiletype = that.detail.fiFiletype
                if(fiFiletype=='1' || fiFiletype=='2' || fiFiletype=='3' || fiFiletype=='4' || fiFiletype=='5' || fiFiletype=='8' ){
                   that.timer = setInterval(that.setDocumentTime, 1000);
                    console.log( that.detail )    
                }   
                
          })
          .catch(err => {});
        },
          // 关闭窗口之前执行
        async beforeunloadHandler(e) {            
            await this.FunaddWatchClass(this.TotalTime);
            clearInterval(this.timer);
        },        
        setDocumentTime(){   //除音视频以外类型时间保存 观看时长最多30分钟
            this.TotalTime++   
            console.log(this.TotalTime)
            if(this.TotalTime >= 1800){
              this.FunaddWatchClass('1800')         
              clearInterval(this.timer)
              this.TotalTime = 0
              console.log('30 mins end,TotalTime:'+ this.TotalTime)   
            }              
        },
        setVdTime(){ //音视频类型时间保存 
           this.TotalTime++
           console.log(this.TotalTime)
        },  
          
         // 当音频播放
        onPlay () {
            this.TotalTime = 0
            this.timer = setInterval(this.setVdTime, 1000);
        },
        // 当音频暂停
        onPause () {            
             clearInterval(this.timer)
             this.FunaddWatchClass(this.TotalTime)
        },
        // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间    
        onTimeupdate(res) {          
         
        },        
        addReadStatus(){        
            var that = this   
            var data = {
                "taskId":this.taskId!='0'?this.taskId:'',
                "memberId": Cookies.get('qslmemberId'),
                "id": this.fiId,
                "readType": this.taskId!='0'?'1':'2'               
            }           
            addReadStatus(data)
            .then(res => {            
                  console.log('addReadStatus save ok')       
            })
            .catch(err => {});
        },
        FunaddWatchClass(whTotalTime){                       
            var that = this           
            var data = {
                "whMemberid": Cookies.get('qslmemberId'),// 企业下人员ID ,                 
                "whPartid": this.fiId    ,//: 课程小节ID    
                "whTotalTime": whTotalTime,//观看时长 ,
                "whSource": "PC",//接口来源 Android iOS ,
                "whTaskId": this.taskId,// 任务ID 
                "whTaskItemId":this.taskTI_ID,//子任务Id 
                "whType":'2',// this.taskId!='0'?'1':'2',//进入类型 1 任务进入 2 直接进入 
                "whWatchtime": '1',//观看位置
                "whClassType": '4',//1、课程 2、语音直播 3、视频直播 4、文档 ,
                "whClassid": '0',//课程ID , 
                "whCreateon":this.$conFun.getNowTime(),// '2021-12-17 22:10:22',
                "whIsEnd": true
            }           
            addWatchClassH(data)
            .then(res => {            
                console.log('WatchClass save ok')        
            })
            .catch(err => {});
        } ,
        prePage(){
          var p = this.pageNum
          p = p>1?p-1:this.pageTotalNum
          this.pageNum = p
        },
        nextPage(){
          var p = this.pageNum
          p = p<this.pageTotalNum?p+1:1
          this.pageNum = p
        },      
        pageLoaded(e){
          this.curPageNum = e
        }   
    },

     destroyed(){
         var fiFiletype = this.detail.fiFiletype
         if(fiFiletype=='6' || fiFiletype=='7'){
           clearInterval(this.timer);
         }else{
           this.FunaddWatchClass(this.TotalTime);  
           clearInterval(this.timer);         
         }           
    }
}    
</script>
<style>
.viewpage{margin:0 auto; width:1200px; text-align:center}
.viewpage .ifa{width:1200px}
.pdf-tab {
    text-align:center; font-size:14px; color:#333; width:100%; margin:0 auto;align-items:center; justify-content:center; padding:24px 0
}
.pdf-tab  div{ margin:0 24px}
</style>


// WEBPACK FOOTER //
// src/views/Knowledge/view.vue